<div class="mm-button-bar">
  @if (!formValid) {
    <mat-card class="button-bar-error">
      <mat-card-content>
        <p style="text-align: center;">Please fix errors before proceeding!</p>
      </mat-card-content>
    </mat-card>
  }
  
  <div class="button-bar-buttons">
    @if (showSaveButton) {
      <button 
        mat-raised-button 
        (click)="saveProgressClick()">
        Save
      </button>
    }
    
    <button 
      mat-stroked-button 
      (click)="goToPrev()">
      Previous
    </button>

    @if(isLastPage()){
      <button 
        mat-raised-button 
        color="primary" 
        (click)="onSubmitClick()">
        Submit
      </button>
    }
    @else {
      <button 
        mat-raised-button 
        color="primary" 
        (click)="goToNext()">
        Next
      </button>
    }
  </div>

</div>